import { i18n } from "../../translate/i18n";

// Cores dos grupos de nota (modelo NPS), validadas para daltonismo e contraste
// no fundo claro (#fafafa) e no escuro (#424242). Nunca aparecem sozinhas:
// todo uso leva o nome do grupo escrito ao lado.
const GROUP_COLORS = {
  light: { detractor: "#CC0036", passive: "#B98900", promoter: "#16915A" },
  dark: { detractor: "#F2556F", passive: "#BC8C00", promoter: "#25A56B" }
};

export const GROUPS = ["promoter", "passive", "detractor"];

const luminance = hex => {
  const channels = hex
    .replace("#", "")
    .match(/../g)
    .map(c => parseInt(c, 16) / 255)
    .map(c => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
  return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
};

// Texto sobre uma cor de grupo: branco ou quase preto, o que tiver mais
// contraste (o âmbar dos neutros não segura texto branco).
export const readableTextOn = hex => {
  const l = luminance(hex);
  return (l + 0.05) / 0.05 > 1.05 / (l + 0.05) ? "#111111" : "#ffffff";
};

export const groupColors = theme =>
  GROUP_COLORS[theme.palette.type === "dark" ? "dark" : "light"];

export const groupOf = (rate, scale) => {
  if (rate >= scale.promoterMin) return "promoter";
  if (rate >= scale.passiveMin) return "passive";
  return "detractor";
};

// Faixas de leitura do NPS mais usadas no mercado.
export const npsZone = nps => {
  if (nps === null || nps === undefined) return null;
  if (nps >= 75) return "excellence";
  if (nps >= 50) return "quality";
  if (nps >= 0) return "improvement";
  return "critical";
};

const locale = () => i18n.language || "pt-BR";

export const formatNumber = (value, digits = 1) =>
  value === null || value === undefined
    ? "—"
    : Number(value).toLocaleString(locale(), {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      });

export const formatNps = value => {
  if (value === null || value === undefined) return "—";
  const rounded = Math.round(value);
  return rounded > 0 ? `+${rounded}` : String(rounded);
};

export const formatPercent = value =>
  value === null || value === undefined ? "—" : `${Math.round(value)}%`;

export const formatDateTime = value => {
  if (!value) return "—";
  const d = new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString(locale(), { dateStyle: "short", timeStyle: "short" });
};

export const formatDay = value => {
  const d = new Date(`${value}T12:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString(locale(), { day: "2-digit", month: "2-digit" });
};

export const firstDayOfMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
};

export const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
};
